import React from 'react';
import Dropzone from "react-dropzone";
import './FileUpload.scss';


export type UploadBulkFileProps = {
    onDrop: any;
    isUploadInProgress: boolean;
};

const UploadBulkFile = (props: UploadBulkFileProps) => ( 
    <div className="container" style={{ width: "50%" }}>
        <div className="row" style={{ height: "450px" }}>
            <div className="col file-upload-container align-self-center">
                <Dropzone onDrop={props.onDrop} accept=".csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values" disabled={props.isUploadInProgress}>
                    {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div>
                                <p>Drag & drop file here to upload!</p>
                                <p>- or -</p>
                                <p>
                                    <label className={`btn btn-primary ${props.isUploadInProgress && 'disabled'}`}>
                                        <span>BROWSE FILES</span>
                                    </label>
                                </p>
                                <p>{" "}</p>
                                <p>
                                    <span className="file-upload-label"
                                        style={{
                                            color: (!isDragActive && "grey")
                                                || ((isDragActive && !isDragReject) && "green")
                                                || ((isDragReject) && "red")
                                        }}
                                    >File must be .csv format</span>
                                </p>
                            </div>
                        </div>
                    )}
                </Dropzone>
            </div>

        </div>
    </div>
);

export default UploadBulkFile;
